import CheckMini from "admin-ui/lib/icons/check-mini"
import DocumentDownload from "admin-ui/lib/icons/document-download"
import GiftLine from "admin-ui/lib/icons/gift-line"
import SearchLine from "admin-ui/lib/icons/search-line"
import { CSSProperties, FC } from "react"
import AddCircle from "./add-circle"
import ArrowDownTray from "./arrow-down-tray"
import ArrowOut from "./arrow-out"
import Buildings from "./buildings"
import Calendar from "./calendar"
import ChatBubbleLeftRight from "./chat-bubble-left-right"
import CheckCircleSolid from "./check-circle-solid"
import ChevronDown from "./chevron-down"
import ChevronLeft from "./chevron-left"
import ChevronLeft1 from "./chevron-left-1"
import ChevronRight from "./chevron-right"
import ChevronRightMini from "./chevron-right-mini"
import ChevronUpDown from "./chevron-up-down"
import Clock from "./clock"
import CogSixTooth from "./cog-six-tooth"
import DocumentCopy from "./document-copy"
import EllipsisHorizontal from "./ellipsis-horizontal"
import Eye from "./eye"
import EyeSlash from "./eye-slash"
import FilledPlus from "./filled-plus"
import FilledStarBlue from "./filled-star-blue"
import FilledStarGray from "./filled-star-gray"
import Filter from "./filter"
import GlobalEurope from "./global-europe"
import Home from "./home"
import ImportIcon from "./import-icon"
import LineGlobe from "./line-globe"
import Link from "./link"
import Loading from "./loading"
import MagnifyingGlass from "./magnifying-glass"
import MailLine from "./mail-line"
import MapPinFill from "./map-pin-fill"
import Minus from "./minus"
import MoneyBag from "./money-bag"
import PencilSquare from "./pencil-square"
import PhoneFill from "./phone-fill"
import { default as ChevronUpMini, default as PlusMini } from "./plus-mini"
import ReceiptPercent from "./receipt-percent"
import ShieldStar from "./shield-star"
import ShieldUser from "./shield-user"
import ShoppingCart from "./shopping-cart"
import Spinner from "./spinner"
import SuccessIcon from "./success-icon"
import TagIcon from "./tag"
import TimeLine from "./time-line"
import TimelineVertical from "./timeline-vertical"
import Trash from "./trash"
import TriangleDownMini from "./triangle-down-mini"
import User from "./user"
import Users from "./users"
import WarningIcon from "./warning-icon"
import WaterBill from "./water-bill"
import XMark from "./x-mark"
import FilledGrayPaper from "./filled-gray-paper"
import CircleTrash from "./circle-trash"
import CaretDownFill from "./caret-down-fill"
import CaretUpFill from "./caret-up-fill"

export type IconProps = {
  className?: string
  style?: CSSProperties
  transform?: string
  id?: string
}

export type Icon = FC<IconProps>

const IconsDefine = {
  "x-mark": "x-mark",
  calendar: "calendar",
  "chevron-up-mini": "chevron-up-mini",
  "plus-mini": "plus-mini",
  "chevron-left-1": "chevron-left-1",
  "global-europe": "global-europe",
  buildings: "buildings",
  "cog-six-tooth": "cog-six-tooth",
  "ellipsis-horizontal": "ellipsis-horizontal",
  minus: "minus",
  trash: "trash",
  "eye-slash": "eye-slash",
  eye: "eye",
  "water-bill": "water-bill",
  "money-bag": "money-bag",
  home: "home",
  "magnifying-glass": "magnifying-glass",
  "receipt-percent": "receipt-percent",
  "shopping-cart": "shopping-cart",
  tag: "tag",
  users: "users",
  spinner: "spinner",
  loading: "loading",
  "chevron-left": "chevron-left",
  "pencil-square": "pencil-square",
  "chevron-down": "chevron-down",
  "chevron-right": "chevron-right",
  "chevron-up-down": "chevron-up-down",
  "arrow-down-tray": "arrow-down-tray",
  "success-icon": "success-icon",
  "warning-icon": "warning-icon",
  "check-circle-solid": "check-circle-solid",
  "add-circle": "add-circle",
  clock: "clock",
  filter: "filter",
  "import-icon": "import-icon",
  "document-copy": "document-copy",
  "arrow-out": "arrow-out",
  "timeline-vertical": "timeline-vertical",
  "document-download": "document-download",
  "chevron-right-mini": "chevron-right-mini",
  user: "user",
  "gift-line": "gift-line",
  "check-mini": "check-mini",
  "search-line": "search-line",
  "filled-star-gray": "filled-star-gray",
  "filled-star-blue": "filled-star-blue",
  "line-globe": "line-globe",
  "filled-plus": "filled-plus",
  "chat-bubble-left-right": "chat-bubble-left-right",
  "triangle-down-mini": "triangle-down-mini",
  "shield-star": "shield-star",
  "shield-user": "shield-user",
  "filled-gray-paper": "filled-gray-paper",
  "circle-trash": "circle-trash",
  link: "link",
  "phone-fill": "phone-fill",
  "mail-line": "mail-line",
  "map-pin-fill": "map-pin-fill",
  "time-line": "time-line",
  "caret-down-fill": "caret-down-fill",
  "caret-up-fill": "caret-up-fill",
} as const

export type IconName = keyof typeof IconsDefine

export type IconsType = Record<IconName, Icon>

export const Icons: IconsType = {
  "x-mark": (props: IconProps) => {
    return <XMark {...props} />
  },
  calendar: (props: IconProps) => {
    return <Calendar {...props} />
  },
  "chevron-up-mini": (props: IconProps) => {
    return <ChevronUpMini {...props} />
  },
  "plus-mini": (props: IconProps) => {
    return <PlusMini {...props} />
  },
  "chevron-left-1": (props: IconProps) => {
    return <ChevronLeft1 {...props} />
  },
  "global-europe": (props: IconProps) => {
    return <GlobalEurope {...props} />
  },
  buildings: (props: IconProps) => {
    return <Buildings {...props} />
  },
  "cog-six-tooth": (props: IconProps) => {
    return <CogSixTooth {...props} />
  },
  "ellipsis-horizontal": (props: IconProps) => {
    return <EllipsisHorizontal {...props} />
  },
  minus: (props: IconProps) => {
    return <Minus {...props} />
  },
  trash: (props: IconProps) => {
    return <Trash {...props} />
  },
  "eye-slash": (props: IconProps) => {
    return <EyeSlash {...props} />
  },
  eye: (props: IconProps) => {
    return <Eye {...props} />
  },
  "water-bill": (props: IconProps) => {
    return <WaterBill {...props} />
  },
  "money-bag": (props: IconProps) => {
    return <MoneyBag {...props} />
  },
  home: (props: IconProps) => {
    return <Home {...props} />
  },
  "magnifying-glass": (props: IconProps) => {
    return <MagnifyingGlass {...props} />
  },
  "receipt-percent": (props: IconProps) => {
    return <ReceiptPercent {...props} />
  },
  "shopping-cart": (props: IconProps) => {
    return <ShoppingCart {...props} />
  },
  tag: (props: IconProps) => {
    return <TagIcon {...props} />
  },
  users: (props: IconProps) => {
    return <Users {...props} />
  },
  spinner: (props: IconProps) => {
    return <Spinner {...props} />
  },
  loading: (props: IconProps) => {
    return <Loading {...props} />
  },
  "chevron-left": (props: IconProps) => {
    return <ChevronLeft {...props} />
  },
  "pencil-square": (props: IconProps) => {
    return <PencilSquare {...props} />
  },
  "chevron-down": (props: IconProps) => {
    return <ChevronDown {...props} />
  },
  "chevron-right": (props: IconProps) => {
    return <ChevronRight {...props} />
  },
  "chevron-up-down": (props: IconProps) => {
    return <ChevronUpDown {...props} />
  },
  "arrow-down-tray": (props: IconProps) => {
    return <ArrowDownTray {...props} />
  },
  "success-icon": (props: IconProps) => {
    return <SuccessIcon {...props} />
  },
  "warning-icon": (props: IconProps) => {
    return <WarningIcon {...props} />
  },
  "check-circle-solid": (props: IconProps) => {
    return <CheckCircleSolid {...props} />
  },
  "add-circle": (props: IconProps) => {
    return <AddCircle {...props} />
  },
  clock: (props: IconProps) => {
    return <Clock {...props} />
  },
  filter: (props: IconProps) => {
    return <Filter {...props} />
  },
  "import-icon": (props: IconProps) => {
    return <ImportIcon {...props} />
  },
  "document-copy": (props: IconProps) => {
    return <DocumentCopy {...props} />
  },
  "arrow-out": (props: IconProps) => {
    return <ArrowOut {...props} />
  },
  "timeline-vertical": (props: IconProps) => {
    return <TimelineVertical {...props} />
  },
  "document-download": (props: IconProps) => {
    return <DocumentDownload {...props} />
  },
  "chevron-right-mini": (props: IconProps) => {
    return <ChevronRightMini {...props} />
  },
  user: (props: IconProps) => {
    return <User {...props} />
  },
  "gift-line": (props: IconProps) => {
    return <GiftLine {...props} />
  },
  "check-mini": (props: IconProps) => {
    return <CheckMini {...props} />
  },
  "search-line": (props: IconProps) => {
    return <SearchLine {...props} />
  },
  "filled-star-gray": (props: IconProps) => {
    return <FilledStarGray {...props} />
  },
  "filled-star-blue": (props: IconProps) => {
    return <FilledStarBlue {...props} />
  },
  "line-globe": (props: IconProps) => {
    return <LineGlobe {...props} />
  },
  "filled-plus": (props: IconProps) => {
    return <FilledPlus {...props} />
  },
  "chat-bubble-left-right": (props: IconProps) => {
    return <ChatBubbleLeftRight {...props} />
  },
  "triangle-down-mini": (props: IconProps) => {
    return <TriangleDownMini {...props} />
  },
  "shield-star": (props: IconProps) => {
    return <ShieldStar {...props} />
  },
  "shield-user": (props: IconProps) => {
    return <ShieldUser {...props} />
  },
  "filled-gray-paper": (props: IconProps) => {
    return <FilledGrayPaper {...props} />
  },
  "circle-trash": (props: IconProps) => {
    return <CircleTrash {...props} />
  },
  link: (props: IconProps) => {
    return <Link {...props} />
  },
  "phone-fill": (props: IconProps) => {
    return <PhoneFill {...props} />
  },
  "mail-line": (props: IconProps) => {
    return <MailLine {...props} />
  },
  "map-pin-fill": (props: IconProps) => {
    return <MapPinFill {...props} />
  },
  "time-line": (props: IconProps) => {
    return <TimeLine {...props} />
  },
  "caret-down-fill": (props: IconProps) => {
    return <CaretDownFill {...props} />
  },
  "caret-up-fill": (props: IconProps) => {
    return <CaretUpFill {...props} />
  },
}

export const RenderIcon = ({
  name,
  id,
  ...reset
}: IconProps & { name?: IconName }) => {
  if (!name) {
    return null
  }
  const Icon = Icons[name]
  return <Icon {...reset} id={id || name} data-testid={`${name}-icon`} />
}

export const IconsList = Object.keys(IconsDefine) as IconName[]
